module.exports = __webpack_public_path__ + "static/img/invest-envir3.b4e9d14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-envir3.jpg
// module id = Ux3G
// module chunks = 0